function toggleMobileMenu() {
  document.querySelector("mobile-menu-ui").openMenu()
}

function closeMobileMenu() {
  document.querySelector("mobile-menu-ui").closeMenu()
}

function returnSubMenu(e) {
  e.preventDefault()
  console.log("returnSubMenu")
  document.querySelector("mobile-menu-ui").toggleSubMenu(e)
  document.querySelector("mobile-menu-ui").openMenu()
}

function returnMainMenu() {
  document.querySelector("mobile-menu-ui").subMenuBack()
}

function openCartDrawer() {
  document.querySelector("cart-drawer").open()
}

function getVisibleAnnouncementHeight() {
  const wrapper =
    document.querySelector(".shopify-section-group-header-group .announcement-bar__wrapper") ||
    document.querySelector(".announcement-bar__wrapper")
  if (!wrapper) return 0

  const section = wrapper.closest("#shopify-section-announcement-bar")
  if (section) {
    const sectionStyle = window.getComputedStyle(section)
    if (sectionStyle.display === "none" || sectionStyle.visibility === "hidden") return 0
  }

  const style = window.getComputedStyle(wrapper)
  if (style.display === "none" || style.visibility === "hidden") return 0

  const measured = wrapper.getBoundingClientRect().height || wrapper.offsetHeight || 0
  return measured > 0 ? measured : 38
}

function syncAnnouncementBarLayout() {
  const barHeight = getVisibleAnnouncementHeight()
  document.documentElement.style.setProperty("--announcement-bar-height", `${barHeight}px`)
  updateHeaderHeight()
}

function updateHeaderHeight() {
  const header = document.querySelector(".header")
  const h = getVisibleAnnouncementHeight() + (header?.offsetHeight || 0)
  document.documentElement.style.setProperty("--header-height", `${h}px`)
}

function initHeaderHeightObserver() {
  syncAnnouncementBarLayout()
  requestAnimationFrame(syncAnnouncementBarLayout)
  setTimeout(syncAnnouncementBarLayout, 100)

  if (typeof ResizeObserver === "undefined") {
    window.addEventListener("resize", syncAnnouncementBarLayout)
    return
  }

  const observer = new ResizeObserver(syncAnnouncementBarLayout)
  const announcement =
    document.querySelector(".shopify-section-group-header-group .announcement-bar__wrapper") ||
    document.querySelector(".announcement-bar__wrapper")
  const header = document.querySelector(".header")
  if (announcement) observer.observe(announcement)
  if (header) observer.observe(header)
}

window.bbeSyncAnnouncementBarLayout = syncAnnouncementBarLayout

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initHeaderHeightObserver)
} else {
  initHeaderHeightObserver()
}

class MobileMenuUi extends HTMLElement {
  constructor() {
    super()

    this.overlay = this.querySelector(".sidemenu-overlay")
    this.mainPanel = this.querySelector(".sidemenu-panel.main-panel")

    // Add an event listener for clicks on the overlay
    this.overlay.addEventListener("click", (e) => this.handleOverlayClick(e))

    this.searchButton = this.querySelector("button[data-controlls-search]")
    if (this.searchButton) {
      this.searchButton.addEventListener("click", this.handleTopSearchButton.bind(this))
    }

    // Add event listeners for all links within the menu
    this.addLinkClickListener()
  }

  addLinkClickListener() {
    const links = this.querySelectorAll("a")
    links.forEach((link) => {
      link.addEventListener("click", () => this.closeMenu())
    })
  }

  refreshSidemenuJudgeme(root = this) {
    const scope = root instanceof Element ? root : this

    const hydrate = () => {
      if (typeof window.jdgm?.customBadges === "function") {
        window.jdgm.customBadges()
        return true
      }
      if (typeof window.jdgm?.customBadge === "function") {
        scope.querySelectorAll(".sidemenu-product__rating.jdgm-widget[data-id]").forEach((el) => {
          window.jdgm.customBadge(el, { product_id: el.dataset.id })
        })
        return true
      }
      return false
    }

    if (!hydrate()) return
    requestAnimationFrame(hydrate)
    setTimeout(hydrate, 320)
  }

  openMenu() {
    this.classList.add("open")
    const html = document.querySelector("html")
    html.style.overflow = "hidden"
    this.refreshSidemenuJudgeme()
  }

  closeMenu() {
    this.classList.remove("open")
    this.subMenuBack()
    const html = document.querySelector("html")
    html.style.overflow = ""
  }

  handleTopSearchButton() {
    this.closeMenu()
    document.querySelector("search-modal").openModal()
  }

  toggleSubMenu(e) {
    const targetSelector = e.target.getAttribute("data-targets")
    console.log(targetSelector)

    const target = this.querySelector('[data-menu-panel-id="' + targetSelector + '"]')
    console.log("target: -> ", target)

    if (target) {
      this.mainPanel.classList.remove("active")
      target.classList.add("active")
      this.refreshSidemenuJudgeme(target)
    }
  }

  subMenuBack() {
    const panels = this.querySelectorAll(".sidemenu-panel.active")
    panels.forEach((panel) => panel.classList.remove("active"))

    this.mainPanel.classList.add("active")
  }

  handleOverlayClick(e) {
    // Check if the click event originated from the overlay, not a child element
    if (e.target === this.overlay) {
      this.closeMenu() // Close the menu
    }
  }
}

customElements.define("mobile-menu-ui", MobileMenuUi)
